import {
    Numbers,
    Numbers as NumbersWithTPM,
} from 'pages/telephony/numbers/new';
import { TpmProviderWrapper } from 'pages/tpm';

const NumbersRoutes = [
    {
        Component: TpmProviderWrapper,
        children: [
            {
                index: true,
                element: <Numbers />,
            },
            {
                path: 'tpm/*',
                element: <NumbersWithTPM />,
            },
        ],
    },
];

export default NumbersRoutes;
